/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { createContext, FC, PropsWithChildren, useMemo } from 'react';

export type LoginContextValue = {
  isManager: boolean;
};

export const LoginContext = createContext<LoginContextValue>(null);

type LoginWrapperProps = PropsWithChildren<{
  isManager?: boolean;
}>;

export const LoginWrapper: FC<LoginWrapperProps> = ({ children, isManager = false }) => {
  const state: LoginContextValue = useMemo(() => {
    return {
      isManager,
    };
  }, [isManager]);

  return <LoginContext.Provider value={state}>{children}</LoginContext.Provider>;
};

export default LoginContext;
